import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { API_BASE } from '../config';

export default function TeacherProtectedRoute({ children }) {
  const [status, setStatus] = useState('loading'); // 'loading' | 'authorized' | 'unauthorized'

  useEffect(() => {
    fetch(`${API_BASE}/api/teacher-user`, { credentials: 'include' })
      .then((r) => (r.ok ? setStatus('authorized') : setStatus('unauthorized')))
      .catch(() => setStatus('unauthorized'));
  }, []);

  if (status === 'loading') return null;
  if (status === 'unauthorized') return <Navigate to="/teacher/login" replace />;
  return children;
}
